/**
 * A utility function to extract the first name from a full name.
 * If the full name contains a space, it returns the substring before the first space.
 * @param fullName
 * @returns
 */
export function getFirstNameFromFullName(
  fullName: string | null | undefined
): string {
  if (!fullName) return '';
  const spaceIndex = fullName.indexOf(' ');
  return spaceIndex > 0 ? fullName.substring(0, spaceIndex) : fullName;
}

/**
 * A utility function to extract the last name from a full name.
 * If the full name contains a space, it returns the substring after the first space.
 * @param fullName
 * @returns
 */
export function getLastNameFromFullName(
  fullName: string | null | undefined
): string {
  if (!fullName) return '';
  const spaceIndex = fullName.indexOf(' ');
  return spaceIndex > 0 ? fullName.substring(spaceIndex + 1) : '';
}
